<template>
    <div class="wrap" :class="{'active': canShow}">
        <div v-show='tabShow == `top`' @click='handleTopClick' @mouseenter="time = 5000" @mouseleave="time = 20">
            <slot name='toTop'>

            </slot>
        </div>
        <div v-show='tabShow == `bottom`' @click='handleBottomClick' @mouseenter="time = 5000" @mouseleave="time = 20">
            <slot name='toBottom'>

            </slot>
        </div>
    </div>
</template>

<script>
let time = 1;
let timer;
let removeEvent
export default {
    name: 'fixedComponent',
    data() {
        return {
            tabShow: 'top',
            canScroll: true,
            canShow: false,
            time: -1,
            beginTime: 21,
            removeEvent: function () { }
        }
    },
    props: {
        stysle: {
            type: Object,
            required: false,
        },
        signElements: {
            type: Object,
            required: true
        }
    },
    created() {
        timer = setInterval(() => {
            this.time--;
            this.beginTime--;
            if (this.time < 0 || this.beginTime > 0) {
                this.canShow = false;
            } else {
                this.canShow = true
            }
        }, 100);
        this.init(this.signElements)
    },
    computed: {
    },
    beforeCreate: function () {
        clearInterval(timer)
        typeof removeEvent == 'function' ? removeEvent() : '';
    },
    mounted: function () {
    },
    methods: {
        init(val) {
            this.canShow = false;
            let { top, bottom, scrollElement } = val;
            if (!top && !bottom) return false;
            if (!top) {
                this.tabShow = 'bottom'
            } else if (!bottom) {
                this.tabShow = 'top'
            }
            let topLine = 0
            if (top) {
                topLine = top.offsetTop
            }
            let bottomLine = 0
            if (bottom) {
                bottomLine = bottom.offsetTop
            }
            let lineStard = (topLine + bottomLine - scrollElement.clientHeight) / 2
            let scrollTop = this.getscrollTop();
            if (scrollTop > lineStard) {
                this.tabShow = 'top'
            } else if (scrollTop <= lineStard) {
                this.tabShow = 'bottom'
            }
            let a = Math.random()
            let __fixedScrollEvent = () => {
                this.time = 20;
                let scrollTop = this.getscrollTop();
                if (scrollTop > lineStard) {
                    this.tabShow = 'top'
                } else if (scrollTop <= lineStard) {
                    this.tabShow = 'bottom'
                }
            };
            removeEvent = function () {
                scrollElement.removeEventListener('scroll', __fixedScrollEvent)
            }
            scrollElement.addEventListener('scroll', __fixedScrollEvent)
            this.time = -1;
        },
        getscrollTop() {
            let { top, bottom, scrollElement } = this.signElements;
            var scroll_top = 0;
            if (scrollElement && scrollElement.scrollTop) {
                scroll_top = scrollElement.scrollTop;
            } else if (document.body) {
                scroll_top = document.body.scrollTop;
            }
            return scroll_top;
        },
        handleBottomClick() {
            let { top, bottom, scrollElement } = this.signElements;
            let topHeight = bottom.offsetTop;
            this.scrollByTop(topHeight)
            this.$emit('goBottom')
        },
        handleTopClick() {
            let { top, bottom, scrollElement } = this.signElements;
            let topHeight = top.offsetTop;
            this.scrollByTop(topHeight)
            this.$emit('goTop')
        },
        scrollByTop(topHeight) {
            if (!this.canScroll) return;
            this.canScroll = false;
            let { scrollElement } = this.signElements;
            let top = -1;
            let interval = setInterval(() => {
                if (Math.abs(scrollElement.scrollTop - topHeight) > 10 && top != scrollElement.scrollTop) {
                    top = scrollElement.scrollTop;
                    scrollElement.scrollTop = scrollElement.scrollTop + (topHeight - scrollElement.scrollTop) / 10;
                } else {
                    scrollElement.scrollTop = topHeight;
                    clearInterval(interval)
                    this.canScroll = true;
                }
            }, 5);
        }

    }
}
</script>

<style scoped>
.wrap {
    position: fixed;
    z-index: 10019;
    bottom: 180px;
    right: -60px;
    cursor: pointer;
    transition: all 0.5s;
}
.active {
    right: 30px;
}
</style>
